import { makePaginatedSearch } from "api/makeApiRequestType/makePaginatedSearch";
import { ValidationCallback } from "validation/validate";

export type OutputRow = {
	id: string;
	url: string;
	containsExternallyBookedMeetings: boolean;
	lastRefreshResult: string | null;
	lastRefreshErrorType: string | null;
};

const flagValidationErrorsInRow: ValidationCallback<OutputRow> = (
	input,
	{ flag, checkField },
	{ uid }
) => {
	checkField("id", { type: "string" });
	checkField("url", { type: "url" });
	checkField("containsExternallyBookedMeetings", { type: "boolean" });
	checkField("lastRefreshResult", { type: "string", canBeNull: true });
	checkField("lastRefreshErrorType", { type: "string", canBeNull: true });
};

type GetICalFeedsToImportParams = {
	uid?: string;
	cacheInMemory?: boolean;
};

export const getICalFeedsToImport = makePaginatedSearch<
	GetICalFeedsToImportParams,
	OutputRow,
	OutputRow
>({ endPoint: "iCalFeedsToImport", flagValidationErrorsInRow });
